"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractPossibleURLSegments = exports.secretValueCopyHandler = exports.isMobileDevice = exports.getActionLabel = exports.getConsumerType = exports.getSecretStatus = void 0;

var _constants = require("./constants");

var getSecretStatus = function getSecretStatus(status) {
  switch (status === null || status === void 0 ? void 0 : status.toLowerCase()) {
    case _constants.secretModuleConstants.pendingText:
      return _constants.translatedStrings.approvalPendingText;

    case _constants.secretModuleConstants.approvalRequiredText:
      return _constants.translatedStrings.approvalRequiredText;

    case _constants.secretModuleConstants.denyText:
      return _constants.translatedStrings.approvalDeniedText;

    case _constants.secretModuleConstants.allowText:
      return _constants.translatedStrings.availableText;

    case _constants.secretModuleConstants.approvedText:
      return _constants.translatedStrings.approvedStatus;

    case _constants.secretModuleConstants.rejectedText:
      return _constants.translatedStrings.rejectedStatus;

    case _constants.secretModuleConstants.timeOutText:
      return _constants.translatedStrings.timeOutStatus;

    case _constants.secretModuleConstants.cancelled:
      return _constants.translatedStrings.cancelled;

    default:
      return _constants.translatedStrings.noneText;
  }
};

exports.getSecretStatus = getSecretStatus;

var getConsumerType = function getConsumerType(consumer) {
  switch (consumer) {
    case _constants.secretModuleConstants.papService:
      return _constants.translatedStrings.accessRequest;

    case _constants.secretModuleConstants.secretManager:
      return _constants.translatedStrings.secret;

    default:
      return _constants.translatedStrings.noneText;
  }
};

exports.getConsumerType = getConsumerType;

var getActionLabel = function getActionLabel(action) {
  if (action) {
    if (action === _constants.secretModuleConstants.secretReadActionName) {
      return _constants.translatedStrings.viewSecret;
    }

    if (action === _constants.secretModuleConstants.profileAccessActionName) {
      return _constants.translatedStrings.accessProfile;
    }

    return action;
  }

  return _constants.translatedStrings.noneText;
};

exports.getActionLabel = getActionLabel;

var isMobileDevice = function isMobileDevice() {
  return window.innerWidth <= 768;
};

exports.isMobileDevice = isMobileDevice;

var secretValueCopyHandler = function secretValueCopyHandler(secretDetailData, templateParameter) {
  return secretDetailData === null || secretDetailData === void 0 ? void 0 : secretDetailData.value[templateParameter === null || templateParameter === void 0 ? void 0 : templateParameter.name];
}; // breaks text into array of possibleURLsegments
// and segments which contain things like
// ['\n', ' ', '\b', '\t', '\r'] are separated from remaining text 
// return [ <possible-url-text>,<other-chars-segment>,....]


exports.secretValueCopyHandler = secretValueCopyHandler;

var extractPossibleURLSegments = function extractPossibleURLSegments() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!text.length) return [];
  var possibleURLtext = '';
  var otherChars = '';
  var segments = [];

  for (var i = 0; i < text.length; i++) {
    if (['\n', ' ', '\b', '\t', '\r'].includes(text.charAt(i))) {
      if (!otherChars && possibleURLtext.length) {
        segments.push(possibleURLtext);
        possibleURLtext = '';
      }

      otherChars = otherChars.concat(text.charAt(i));
    } else {
      if (!possibleURLtext && otherChars.length) {
        segments.push(otherChars);
        otherChars = '';
      }

      possibleURLtext = possibleURLtext + text.charAt(i);
    }
  }

  possibleURLtext && segments.push(possibleURLtext);
  otherChars && segments.push(otherChars);
  return segments;
};

exports.extractPossibleURLSegments = extractPossibleURLSegments;